import React from "react";
import { useLocation, useHistory } from "react-router-dom";
import queryString from "query-string";
import { TextField } from "@material-ui/core";

const NumberPrefixFilter = () => {
  const location = useLocation();
  const history = useHistory();

  const searchParams = queryString.parse(location.search);

  const onChangeSearchValue = (event) => {
    const searchQuery = queryString.parse(location.search);

    const searchQueryParams = new URLSearchParams({
      ...searchQuery,
      page: "1",
    });

    searchQueryParams.delete("numberPrefix");

    if (event.target.value) {
      searchQueryParams.append("numberPrefix", event.target.value);
    }

    history.push({
      path: location.path,
      search: new URLSearchParams(searchQueryParams).toString(),
    });
  };

  return (
    <TextField
      defaultValue={searchParams?.numberPrefix}
      name={"numberPrefixSearch"}
      onChange={onChangeSearchValue}
      placeholder={"Search by SKU"}
      fullWidth
      margin="dense"
      type="text"
      variant="outlined"
    />
  );
};

export default NumberPrefixFilter;
